import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

interface ICountdownContext {
  timeLeft: number;
  setCountdown: (val: number) => void;
}

interface ICountdownProvider {
  children: React.ReactNode;
}

const CountdownContext = createContext<ICountdownContext>({} as ICountdownContext);

const CountdownProvider: React.FC<ICountdownProvider> = ({ children }) => {
  const [timeLeft, setCountdown] = useState<number>(0);

  useEffect(() => {
    if (timeLeft === 0) {
      return;
    }

    const intervalId = setInterval(() => {
      setCountdown(timeLeft - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft]);

  const contextValues = useMemo(
    () => ({
      timeLeft,
      setCountdown,
    }),
    [timeLeft],
  );

  return <CountdownContext.Provider value={contextValues}>{children}</CountdownContext.Provider>;
};

const useCountdown = (): ICountdownContext => {
  const context = useContext(CountdownContext);

  if (!context) {
    throw new Error('useCountdown must be used within an CountdownProvider');
  }

  return context;
};

export { CountdownProvider, useCountdown };
